import { render, staticRenderFns } from "./ComingSoonEur.vue?vue&type=template&id=5c150853"
import script from "./ComingSoonEur.vue?vue&type=script&lang=js"
export * from "./ComingSoonEur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports